<!-- eslint-disable max-len -->
<template>
  <div>
    <Card title="Payout List">
      <template v-slot:body>
        <div>
          <div class="pb-6 flex justify-between items-center">
            <div class="flex items-center">
              <div class="mr-2">
                <form-item label='Filter Date'>
                  <template v-slot>
                    <vue-monthly-picker
                      v-model="selectedMonth"
                      :monthLabels="monthLabels"
                      :selectedBackgroundColor="'#1a202c'"
                      :clearOption="false"
                      :max="maxMonth"
                      @selected="onChangeDate"
                    >
                    </vue-monthly-picker>
                  </template>
                </form-item>

              </div>
            </div>
          </div>
          <data-tables-server ref="tableTransaction" :data="data" :total="total" :pagination-props="{ background: true,pageSizes: [displayingItem] }" @query-change="onChangeTable" >
            <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
            </el-table-column>
            <el-table-column label="Actions" align="right" min-width="150px">
              <template slot-scope="scope">
                <div class="static inline-block text-left container-action">
                  <VueCustomTooltip label="Detail" :position="'is-left'">
                    <button @click="viewDetail(scope.row)" class="p-2 mr-2 w-8 rounded bg-green-400 hover:bg-green-500 focus:outline-none" >
                      <font-awesome-icon class="text-white" :icon="['fa', 'eye']" />
                    </button>
                  </VueCustomTooltip>
                </div>
              </template>
            </el-table-column>
          </data-tables-server>
        </div>
      </template>
    </Card>
    <ModalDialog
      ref="detailArtist"
      :isShowingModal="isShowingDetailModal"
      :isLoading="isLoading"
      title="Detail Artist"
      labelSubmit="Submit as Transferred"
      @toggleModal="isShowingDetailModal = false"
      @save="makePayment()"
    >
      <template slot="body" >
        <div class="py-6">
          <form-item label='Artist Name'>
            <template v-slot>
              <p class="text-left font-bold">{{ artist.name }}</p>
            </template>
          </form-item>
          <form-item label='Email'>
            <template v-slot>
              <p class="text-left font-bold">{{ artist.email }}</p>
            </template>
          </form-item>
          <form-item label='Bank'>
            <template v-slot>
              <p class="text-left font-bold">{{ !!artist.bank?artist.bank.bank:'-' }}</p>
            </template>
          </form-item>
          <form-item label='Account Holder'>
            <template v-slot>
              <p class="text-left font-bold">{{ !!artist.bank?artist.bank.account_name:'-' }}</p>
            </template>
          </form-item>
          <form-item label='Account Number'>
            <template v-slot>
              <p class="text-left font-bold">{{ !!artist.bank?artist.bank.account_number:'-' }}</p>
            </template>
          </form-item>
          <form-item label='Swift Code'>
            <template v-slot>
              <p class="text-left font-bold">{{ !!artist.bank?artist.bank.swift_code:'-' }}</p>
            </template>
          </form-item>
          <form-item label='Amount'>
            <template v-slot>
              <p class="text-left font-bold">{{ artist.amount }}</p>
            </template>
          </form-item>
          <form-item label='Paid Amount'>
            <div class="inline-flex w-full gap-4 items-center">
              $ <Input
              v-model="input.amount"
              placeholder="ex. 5"
              :error="$v.input.amount.$dirty && (!$v.input.amount.required  || !$v.input.amount.decimal)"
            />
            </div>
            <div class="flex flex-col pt-2">
              <text-error v-if="$v.input.amount.$dirty && !$v.input.amount.required" text="Please fill Amount." />
              <text-error v-if="$v.input.amount.$dirty && !$v.input.amount.decimal" text="Please fill Amount with number." />
            </div>
          </form-item>
          <form-item label='Transfer Date'>
            <template v-slot>
              <el-date-picker
                size="large"
                v-model="input.payment_date"
                type="date"
                :clearable="false"
                placeholder="Pick a day"
                style="width: 100%"
              >
              </el-date-picker>
              <div class="flex flex-col pt-2">
                <text-error v-if="$v.input.payment_date.$dirty && !$v.input.payment_date.required" text="Please fill Payment Date." />
              </div>
            </template>
          </form-item>
        </div>
      </template>
    </ModalDialog>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import helperMixins from '../mixins/helpers.mixins';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import VueMonthlyPicker from 'vue-monthly-picker';
import ModalDialog from '@/components/Common/ModalDialog';
import ModalDialogDetail from '@/components/Common/ModalDialogDetail';
import moment from 'moment';
import { Button, FormItem, Input,TextArea,TextError } from '@/components/Layout/Form';
import Card from '@/components/Layout/Card.vue';
import { validationMixin } from 'vuelidate';
import { required, decimal } from 'vuelidate/lib/validators';

const displayingItems = 50;

export default {
  name: 'PayoutListPage',
  mixins: [validationMixin,helperMixins],
  data() {
    return {
      isShowingDetailModal: false,
      isLoading: false,
      selectedMonth: moment(),
      maxMonth: moment(),
      data: [],
      total: 0,
      displayingItem: displayingItems,
      titles: [{
        prop: 'artist.name',
        label: 'Artist Name',
      }, {
        prop: 'artist.email',
        label: 'Email',
      }, {
        prop: 'amount_text',
        label: 'Amount',
      }],
      artist: {
        name: '',
        email: '',
        bank: {
          bank: '',
          account_name: '',
          account_number: '',
          swift_code: '',
        },
        amount: '',
        created_at: '',
      },
      payoutId: null,
      filter: {
        page: 1,
        per_page: displayingItems,
        sortby: 'id',
        sortorder: 'desc',
        month: moment().format('YYYY-MM'),
      },
      monthLabels: [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
      ],
      input:{
        payment_date: new Date(),
        amount: 0
      }
    };
  },
  validations() {
    return {
      input: {
        amount : {
          required,
          decimal,
        },
        payment_date: {
          required
        }
      }
    }
  },
  async mounted() {
    this.toggleDashboardProfile(false);
    await this.requestListPayout(this.filter);
    // this.refineData();
  },
  computed: {
    ...mapGetters('FinanceModule', ['listPayout']),
  },
  watch: {
    listPayout: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (this.listPayout.data !== undefined) {
          this.data = this.listPayout.data.data.map(pay => ({ ...pay, amount_text: `$${this.formatPrice(parseFloat(pay.request_amount).toFixed(2))}` }));
          this.total = this.listPayout.data.total;
        }
      },
    },
  },
  methods: {
    ...mapActions('FinanceModule', ['requestListPayout', 'requestMakePayment']),
    async search() {
      await this.requestListPayout(this.filter);
      // this.refineData();
    },
    async reset() {
      this.$refs.tableTransaction.$refs.elTable.clearSort();
      this.filter = {
        page: 1,
        per_page: this.displayingItem,
        sortby: 'id',
        sortorder: 'desc',
        start_date: '',
        end_date: '',
      };
      this.search();
    },
    resetForm(){
      this.$v.$reset();
      this.input = Object.assign({}, {
        amount: 0,
        payment_date: new Date(),
      })
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const pageSize = queryInfo.pageSize;
      this.displayingItem = pageSize;
      const page = queryInfo.page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'id';
      }
      sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      this.filter = Object.assign(this.filter, { per_page: this.displayingItem, sortorder, sortby, page });
      await this.requestListPayout(this.filter);
    },
    async onChangeDate(res) {
      // month index start from 0
      this.filter = { ...this.filter,
        month: moment(res).format('YYYY-MM'),
      };
      await this.search();
    },
    viewDetail(row) {
      this.resetForm();
      this.payoutId = row.id;
      this.artist = row.artist;
      this.artist = { ...this.artist, amount: row.amount_text, created_at: row.created_at };
      this.isShowingDetailModal = !this.isShowingDetailModal;
      this.input = {
        amount: parseFloat(row.request_amount).toFixed(2),
        payment_date: new Date(),
      }
    },
    async makePayment() {
      this.$v.$touch();
      if (this.$v.$invalid){
        return;
      }
      const data = {
        id: this.payoutId,
        amount: Number(this.input.amount),
        payment_date: moment(this.input.payment_date).format('YYYY-MM-DD'),
      };
      const filter = this.filter;
      Vue.swal({
        title: 'Submit as Transferred',
        text: `Are you sure to Submit as Transferred with artist : ${this.artist.name}`,
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          await this.requestMakePayment({ data, filter });
          this.isShowingDetailModal = false;
          this.$swal('Approved', 'You successfully approve this request', 'success');
        }
      });
    },
  },
  components: {
    VueCustomTooltip,
    VueMonthlyPicker,
    ModalDialog,
    ModalDialogDetail,
    Button,
    Card,
    FormItem,
    Input,
    TextArea,
    TextError
  },
};
</script>
<style scoped>
.z-1000{
  z-index: 1000;
}
.mx-400{
  max-height: 50%;
  height: 50vh;
}
</style>



// WEBPACK FOOTER //
// src/views/PayoutList.vue